import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  duration: string;
  views: string;
  date: string;
  isHot?: boolean;
  isNew?: boolean;
  size?: 'normal' | 'large';
}

export default function VideoCard({
  id,
  title,
  category,
  categorySlug,
  imageUrl,
  duration,
  views,
  date,
  isHot,
  isNew,
  size = 'normal',
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block"
    >
      <div className={`relative overflow-hidden rounded-lg mb-3 ${size === 'large' ? 'aspect-[16/9]' : 'aspect-[16/9]'}`}>
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={title}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
        <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded-md font-label">
          {duration}
        </div>
        {isHot && (
          <div className="absolute top-2 left-2 bg-accent-500 text-white text-xs px-2 py-0.5 rounded-md font-label">
            热门
          </div>
        )}
        {isNew && (
          <div className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-md font-label">
            最新
          </div>
        )}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-600 cursor-pointer">
            <i className="ri-play-fill text-2xl"></i>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug mb-2">
        {title}
      </h3>
      <div className="flex items-center gap-3 text-xs text-foreground-500">
        <Link
          to={`/category/${categorySlug}`}
          className="text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          onClick={(e) => e.stopPropagation()}
        >
          {category}
        </Link>
        <span className="flex items-center gap-1">
          <i className="ri-eye-line text-xs"></i>
          {views}
        </span>
        <span className="hidden sm:inline">{date}</span>
      </div>
    </Link>
  );
}